import styled from 'styled-components';

import Message from '../Message';

export const StyledMessage = styled(Message)`
  border: ${({ theme }) => theme.colors.caution} 1px solid;
  background: ${({ theme }) => theme.colors.cautionBackground};
`;
